export default __webpack_public_path__ + "static/media-1-784c0f63926567f04d8191c387d7d768.png";